export default "__VITE_ASSET__BrbgbhKg__"